import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ReplaySubject, takeUntil } from 'rxjs';

import { coreSelectors } from 'app/core/state';
import { Loggable } from 'app/utils/logging/loggable';
import User from 'entity/User';

import { ScootaverseEditService } from '../../services/scootaverse-edit.service';

@Component({
  selector: 'create-scootaverse',
  templateUrl: './create-scootaverse.component.html',
  styleUrls: ['./create-scootaverse.component.scss'],
  standalone: false,
})
export class CreateScootaverseComponent extends Loggable implements OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);
  private user: User | undefined;

  public constructor(
    private scootaverseEditService: ScootaverseEditService,
    private router: Router,
    private store: Store,
  ) {
    super();
    this.setDisplayName('CreateScootaverseComponent');
    this.store
      .select(coreSelectors.getUserEntity)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user) => (this.user = user));
  }

  public async createScootaverse(): Promise<void> {
    // check for loggin
    if (!this.user) {
      void this.router.navigate(['/welcome']);
      return;
    }

    await this.scootaverseEditService.createScootaverse();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
